import React, { useState, useEffect, useRef } from 'react'

import Grid from '@material-ui/core/Grid';
import ImputComponent from "./../../InputComponent"
import { LanguageFactory, LocalPersistence } from '../../../factories';
import { useLanguage } from '../../../store/languageContext'
import SearchDebounceBar from '../../SearchDebounce';
import SearchIcon from '@material-ui/icons/Search';
import { PropertySearch } from '../../../factories/propertySearchs';
import { Button, Card, Table } from 'antd';
import { getOtherpayments } from '../../../services/otherPayments';
import EditOtherAcceptedPayments from './Edit';
import PageContainer from '../../CSIComponents/PageContainer';
import AddOtherAcceptedPayments from './Add';
import Loading from '../../Loading';
import { sortHelper } from '../../../helpers/misc/sortHelper'

const OtherAcceptedPayments = (props: any) => {
    // const response = mockData;
    const { language } = useLanguage()
    const lang = new LanguageFactory(language)
    const initialRender = useRef(true);
    const [searchs, setSearch] = useState<string[]>([]);
    const [dataSource, setDataSource] = useState([]);
    const [addFlag, setAddFlag] = useState(false);
    const [editFlag, setEditFlag] = useState(false);
    const [total, setTotal] = useState(dataSource.length)
    const [data, setData] = useState(dataSource);
    const [rowData, setRowData] = useState([]);
    const [addLoading, setAddLoading] = useState(false)
    const columns = [
        {
            title: '',
            key: 'index',
            render: (text: string, record: [], index: number) => index += 1,
            width: '40px'
        },
        {
            title: 'Payment Type',
            dataIndex: 'paytype',
            key: 'paytype',
            sorter: (a: [], b: []) => sortHelper(a, b, 'paytype'),
            showSorterTooltip: false
        },
        {
            title: 'Use For Guarantee',
            dataIndex: 'useforguarantee',
            key: 'useforguarantee',
            sorter: (a: [], b: []) => sortHelper(a, b, 'useforguarantee'),
            showSorterTooltip: false
        },
        {
            title: 'Use For Deposit',
            dataIndex: 'usefordeposit',
            key: 'usefordeposit',
            sorter: (a: [], b: []) => sortHelper(a, b, 'usefordeposit'),
            showSorterTooltip: false
        },
        {
            title: 'Use For Payment',
            dataIndex: 'useforpayment',
            key: 'useforpayment',
            sorter: (a: [], b: []) => sortHelper(a, b, 'useforpayment'),
            showSorterTooltip: false
        }
    ]

    const onChangeSearch = (term: string) => {
        setSearchTerm(term)
        onDebounce(term)
    }
    const {
        searchTerm, setSearchTerm, searchTermDebounced, onDebounce
    } = SearchDebounceBar()
    const recentlySearchs = () => {
        return searchs.map((search, index) => {
            return (
                <span key={index} onClick={() => recoverSearch(search)}>
                    &nbsp;{search}{searchs.length - 1 === index ? '.' : ','}
                </span>
            )
        })
    }

    const recoverSearch = (search: string) => {
        setSearchTerm(search)
        filterData(search)
        onDebounce(search)
    }

    const saveNewSearch = (term: string) => {
        const stackSearchs = new PropertySearch(searchs)
        setSearch(stackSearchs.add(term))
    }

    const afterDebounce = (term: string) => {
        if (term) {
            saveNewSearch(term)
        }
        filterData(term)
    }

    const getData = async () => {
        const get_session = new LocalPersistence('session')
        const session: any = await get_session.getSessionPersistence()
        setAddLoading(true)
        const res = await getOtherpayments(session.supplier, session.propertyId);
        setAddLoading(false)
        const resData: any = res && res.property && res.property.otherPayments && res.property.otherPayments.otheracceptedpayments && res.property.otherPayments.otheracceptedpayments.length > 0 ? res.property.otherPayments.otheracceptedpayments : [];
        resData.forEach((item: any, index: number) => { item.key = '' + index; })
        setDataSource(resData);
        setData(resData)
    }
    useEffect(() => {
        getData()
    }, [])
    const filterData = async (query: string) => {
        const filterData = data.filter((item: any) => {
            const itemData: any = {}
            columns.forEach((col: any) => {
                if (typeof item[col.dataIndex] === 'string') {
                    itemData[col['dataIndex']] = item[col.dataIndex].toLowerCase();
                }
            })
            return JSON.stringify(itemData)
                .indexOf(query.toLocaleLowerCase()) > -1;

        })

        setDataSource(filterData);
    }
    const cancelAddAndEdit = () => {
        getData()
        setAddFlag(false);
        setEditFlag(false);
        props.disableTabPanes(false)
        props.cancelEditable();
    }
    useEffect(() => {
        setTotal(dataSource.length)
    }, [dataSource])
    // search functionality
    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false;
        } else {
            afterDebounce(searchTermDebounced);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps 
    }, [searchTermDebounced])
    return (addLoading ? <Loading type="large" /> : <>
        {!addFlag && !editFlag && <PageContainer>
            <Card className="db-page db-table-page">
                <Grid container spacing={0} className="py-0">
                    <Grid item xs={12} className="p-0">
                        <div className="db-title-wrap">
                            <div className="db-title">Other Accepted Payments</div>
                            <div><Button className="db-add-btn" onClick={() => { setAddFlag(true); setEditFlag(false); props.isEditable(); props.disableTabPanes(true) }}>Add</Button></div>
                        </div>
                    </Grid>
                    <Grid item xs={4} className="pb-0 px-0 my-0">
                        <div className="db-content-table-wrap db-mb-8">
                        <ImputComponent
                            className = 'SearchBar'
                            label='Search'
                            labelShrink = {true}
                            value={searchTerm}
                            onChange={onChangeSearch}
                            placeholder='Search Other Accepted Payments'
                            endAdornment={<SearchIcon style={{color: '#9a9a9a'}}/>}
                        />
                        <div className="recentlySearchs">
                            <p>{lang.translate(language, 'recently_searched')}: {recentlySearchs()}</p>
                        </div>
                        </div>
                    </Grid>
                    <Grid item xs={12} className="p-0">
                    <div className="db-content-table-wrap">
                        <Table
                            columns={columns}
                            dataSource={
                                dataSource
                            }
                            pagination={{
                                size: "small",
                                total,
                                showSizeChanger: true,
                                showTotal: (total, range) => `Total ${total} items, Current ${range[0]}-${range[1]}`,
                                defaultPageSize: 10,
                                defaultCurrent: 1,
                                onChange: (page, pageSize) => {
                                    console.log(page + '===' + pageSize)
                                }
                            }}
                            onRow={record => {
                                return {
                                    onClick: event => {
                                        setAddFlag(false);
                                        setEditFlag(true);
                                        setRowData(record);
                                        // props.isEditable();
                                        //props.disableTabPanes(true)
                                    },
                                };
                            }}
                        />
                        </div>
                    </Grid>
                </Grid>
            </Card>
        </PageContainer>}
        {addFlag && <AddOtherAcceptedPayments cancelAddAndEdit={cancelAddAndEdit} />}
        {editFlag && <EditOtherAcceptedPayments isEditable={props.isEditable} disableTabPanes={props.disableTabPanes} cancelAddAndEdit={cancelAddAndEdit} rowData={rowData} setRowData={setRowData} />}
    </>

    )
}

export default OtherAcceptedPayments;
